module.exports = __webpack_public_path__ + "img/Actinidia_chinensis.97e340c0.jpg";